import React from 'react';
import { SVGProps } from './types';

const DeleteIcon = (props: SVGProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M13 3.667l-.667 11H3.667L3 3.667M1.333 3.666h4m0 0l1-2.333h3.334l1 2.333m-5.334 0h5.334m4 0h-4M6.333 11V7M9.667 11V7"
      />
    </svg>
  );
};

export { DeleteIcon };
